import { graphql } from '../graphql/generated';

export const OPEN_REQUESTS_QUERY = graphql(`
  query OpenRequests($currentDoctorId: ID!, $doctorId: ID!) {
    openRequests(doctorId: $currentDoctorId, svnr: null) {
      id
      createdAt
      modifiedAt
      sampledAt
      status
      comment
      orders {
        id
        number
        type
        lab {
          id
          shortName
        }
        orderLabels {
          id
          printedAt
          specimenId
          testTubeId
          location
          specialPrinterRequired
        }
        orderFiles {
          id
          fileName
          printable
          printRequired
          printBeforeSend
          printCopies
          printedAt
        }
        orderParameters {
          id
          billingType
        }
      }
      ordersTruncated
      aisLinked
      patientData {
        birthday
        city
        country
        email
        externalId
        firstName
        lastName
        gender
        zip
        svnr
        title
        street
        phone
        insuranceCode
        idCardAuthority
        idCardNumber
        idCardType
        insuranceCategory
        insuredPerson {
          phone
          street
          title
          svnr
          zip
          birthday
          gender
          firstName
          email
          country
          city
          lastName
        }
      }
      createdByFirstName
      createdByLastName
      modifiedByFirstName
      modifiedByLastName
    }

    doctor(id: $doctorId) {
      id
      flipParamNames
      addEmptyLabels
      csvImportEnabled
      addZplLabels
      zplLabelTemplate
    }
  }
`);

export const DELETE_OPEN_REQUESTS_MUTATION = graphql(`
  mutation DeleteOpenRequests($requestIds: [ID!]!) {
    deleteOpenRequests(requestIds: $requestIds)
  }
`);
